//FormularioLancamento

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { styles } from '../styles/form.mjs';
import { useParams } from 'react-router-dom';
import { useClientNavigation } from '../hooks/useClientNavigation.mjs';
import { apiUrl2, apiUrl2Put } from '../api/client.mjs';

const FormularioLancamento = () => {
    const { navigateBack } = useClientNavigation();
    const { id } = useParams();
    const clienteId = process.env.REACT_APP_CLIENT_ID;
    const [nome, setNome] = useState('');
    const [link, setLink] = useState('');
    const [detalhes, setDetalhes] = useState(['', '', '']);

    useEffect(() => {
        if (id) {
            axios.get(apiUrl2(id))
                .then(response => {
                    if (response.data.length > 0) {
                        const { plataforma_nome, plataforma_link, plataforma_detalhes } = response.data[0];
                        setNome(plataforma_nome || '');
                        setLink(plataforma_link || '');
                        setDetalhes(plataforma_detalhes || []);
                    } else {
                        console.log("Nenhum dado encontrado para essa plataforma.");
                    }
                })
                .catch(error => {
                    console.error('Erro ao buscar detalhes da plataforma:', error);
                });
        }
    }, [id, clienteId]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const data = {
            nome,
            link,
            detalhes: detalhes.filter(d => d.trim() !== '')
        };

        const url = id ? apiUrl2Put(id) : apiUrl2('');
        const method = id ? 'put' : 'post';

        axios({ method, url, data })
            .then(() => navigateBack())
            .catch(error => console.error("Operation failed: ", error));
    };

    return (
        <form onSubmit={handleSubmit} style={styles.form}>
            <label style={styles.label}>Nome:</label>
            <input style={styles.input} type="text" value={nome} onChange={(e) => setNome(e.target.value)} />

            <label style={styles.label}>Link:</label>
            <input style={styles.input} type="text" value={link} onChange={(e) => setLink(e.target.value)} />

            {detalhes.map((detalhe, index) => (
                <div key={index}>
                    <label style={styles.label}>Detalhe {index + 1}:</label>
                    <input style={styles.input} type="text" value={detalhe} onChange={(e) => {
                        let newDetalhes = [...detalhes];
                        newDetalhes[index] = e.target.value;
                        setDetalhes(newDetalhes);
                    }} />
                </div>
            ))}

            <button style={styles.button} type="submit">Salvar</button>
        </form>
    );
};

export default FormularioLancamento;
